import { Box, Tooltip, type TooltipProps } from '@chakra-ui/react';
import { type FC, type ReactNode } from 'react';

import { Icon } from '$/components/common/Icon';

interface Props extends Omit<TooltipProps, 'children'> {
  info: string | ReactNode;
  icon?: ReactNode;
}

export const InfoTooltip: FC<Props> = ({ info, icon, ...props }) => {
  return (
    <Tooltip p='3' border='1px' borderColor='border' label={info} {...props}>
      <Box cursor='help'>
        {icon ? (
          icon
        ) : (
          <Icon
            icon='info'
            color='border'
            cursor='help'
            _hover={{ cursor: 'pointer' }}
          />
        )}
      </Box>
    </Tooltip>
  );
};
